document.addEventListener('DOMContentLoaded', () => {
  const placeholder = document.querySelector('[data-breadcrumb-collection]');
  if (!placeholder) return;

  const referrer = document.referrer;
  if (!referrer || !referrer.includes('/collections/')) return;

  const match = referrer.match(/\/collections\/([^//?]+)/);
  if (!match?.[1]) return;

  const handle = match[1];

  fetch(`/collections/${handle}.json`)
    .then((res) => {
      if (!res.ok) return;
      return res.json();
    })
    .then((data) => {
      if (!data?.collection?.title) return;

      const link = placeholder.querySelector('a');
      if (!link) return;

      link.textContent = data.collection.title;
      link.href = `/collections/${handle}`;
      placeholder.hidden = false;
    })
    .catch((error) => {
      console.warn('Failed to fetch collection info:', error);
    });
});
